import React, { useEffect, useState, useRef } from "react";
import time from "../../../assets/svg/time.svg";
import close from "../../../assets/svg/close.svg";
import DOMPurify from "dompurify";
import { createDockSetupApi, getDockGateApi, getUserApi, updateDockSetupApi } from "../master-api";
import { Container, Row, Col } from "react-bootstrap";
import SearchWithAPI from "../../searchbox/searchbox.js";
import CommonAsyncSelect from "../../common/custom-select";
import { getCustomerSugApi, getDeptApi, getLocationApi, getProductTypeSuggApi, getVendorSugApi } from "../customers/customer-api.js";
import { QRCodeSVG } from "qrcode.react";
import download from "../../../assets/svg/download-qr.svg";
import print from "../../../assets/svg/print.svg";

function DockAdd({ dockId, onSuccess, onClose }) {
  const [isClosing, setIsClosing] = useState(false);

  const [dockDetails, setDockDetails] = useState({});

  const [description, setDescription] = useState("");
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const handleChange = (e) => {
    setDescription(e.target.value);
  };

  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
  };
  const handleDeptChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedDept(selectedOptions);
  };
  const handleVendorChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedVendor(selectedOptions);
  };
  const handleCustomerChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedCustomer(selectedOptions);
  };
  const handleProductTypeChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedProductType(selectedOptions);
  };
  const getLocationData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getLocationApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };
  const getDepartmentData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getDeptApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };
  const getVendorData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getVendorSugApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const getCustomerData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getCustomerSugApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const getProductTypeData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getProductTypeSuggApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };
  /* useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [show]); */

  /* if (!show) return null; */

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "stretch",
    zIndex: 1050,
    opacity: isClosing ? 0 : 1,
    transition: "opacity 0.3s ease-out",
  };

  const containerStyle = {
    padding: "24px",
    width: "100%",
    maxWidth: "700px",
    backgroundColor: "#fff",
    height: "100vh",
    overflowY: "auto",
    transform: isClosing ? "translateX(100%)" : "translateX(0)",
    transition: "transform 0.3s ease-out",
    animation: "slideInFromRight 0.3s forwards",
  };

  const labelStyle = {
    marginBottom: "6px",
    display: "block",
    fontFamily: "Epilogue",
    fontWeight: "500",
    fontSize: "13px",
    color: "#172B4D",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    height: "40px",
    border: "1px solid #E5E7EB",
    fontSize: "13px",
    fontFamily: "Epilogue",
    fontWeight: "400",
    outline: "none",
    color: "#8790A1",
  };

  const inlineFieldsStyle = {
    display: "flex",
    gap: "16px",
    marginBottom: "20px",
  };

  const timeInputWrapperStyle = {
    position: "relative",
  };

  const timeIconStyle = {
    position: "absolute",
    right: "13px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "17px",
    height: "17px",
  };

  const textareaStyle = {
    width: "100%",
    padding: "10px",
    outline: "none",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    fontSize: "14px",
    resize: "none",
    minHeight: "80px",
    color: "#8790A1",
  };

  const actionsStyle = {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginTop: "20px",
  };

  const styleTag = (
    <style>
      {`
        @keyframes slideInFromRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
      `}
    </style>
  );

  const apiUrl = process.env.REACT_APP_API_URL;
  const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [dockCode, setDockCode] = useState("");
  const [dockName, setDockName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [locationOption, setLocationOption] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [usersOption, setUsersOption] = useState([]);
  const [validations, setValidations] = useState({
    code: "",
    name: "",
    location_id: "",
    available_in_time: "",
    available_out_time: "",
    description: "",
    display_name: "",
    users: "",
    departments: "",
    customers: "",
    vendors: "",
    products_types: "",
  });

  useEffect(() => {
    if (dockId != null && dockId !== "") {
      getDockEdit();
    }
  }, [dockId]);

  const getDockEdit = async () => {
    try {
      const response = await getDockGateApi(dockId);
      if (response && response.status === 200 && response.data?.success === true) {
        const dockMaster = response.data.dock;
        setDockDetails(dockMaster);
        setDockCode(dockMaster.code ?? "");
        setDockName(dockMaster.name ?? "");
        setDisplayName(dockMaster.display_name ?? "");
        
        if (dockMaster.location_id || dockMaster.location) {
          setLocationOption({
            value: String(dockMaster.location_id ?? ""),
            label: String(dockMaster.location ?? dockMaster.location_name ?? "")
          });
        } else {
          setLocationOption(null);
        }

        setStartTime(dockMaster.available_in_time ?? "");
        setEndTime(dockMaster.available_out_time ?? "");
        
        const users = Array.isArray(dockMaster.users)
          ? dockMaster.users.map(u => ({
              value: String(u.value || u.id || u.uuid || ''),
              label: String(u.label || u.name || u.user_name || '')
            }))
          : [];
        setUsersOption(users);

        setDescription(dockMaster.description ?? "");

        const depts = Array.isArray(dockMaster.departments)
          ? dockMaster.departments.map(d => ({
              value: String(d.value || d.id || d.uuid || ''),
              label: String(d.label || d.name || d.department_name || '')
            }))
          : [];
        setSelectedDept(depts);

        const vendors = Array.isArray(dockMaster.vendors)
          ? dockMaster.vendors.map(v => ({
              value: String(v.value || v.id || v.uuid || ''),
              label: String(v.label || v.name || v.vendor_name || '')
            }))
          : [];
        setSelectedVendor(vendors);

        const customers = Array.isArray(dockMaster.customers)
          ? dockMaster.customers.map(c => ({
              value: String(c.value || c.id || c.uuid || ''),
              label: String(c.label || c.name || c.customer_name || '')
            }))
          : [];
        setSelectedCustomer(customers);

        const productTypes = Array.isArray(dockMaster.product_types)
          ? dockMaster.product_types.map(p => ({
              value: String(p.value || p.id || p.uuid || ''),
              label: String(p.label || p.name || p.product_type_name || '')
            }))
          : [];
        setSelectedProductType(productTypes);

        setValidations({
          code: "",
          name: "",
          location_id: "",
          available_in_time: "",
          available_out_time: "",
          description: "",
          display_name: "",
          users: "",
          departments: "",
          customers: "",
          vendors: "",
          products_types: "",
        });
      }
      return response?.data;
    } catch (err) {
      console.error("Error fetching dock master edit:", err);
    }
  };

  const handleLocationDropdownChange = (option) => {
    setLocationOption(option);
  };
  const fetchOptions = (inputValue, callback) => {
    setTimeout(async () => {
      const response = await getUserApi(inputValue);
      if (response && response.status === 200 && response.data?.success === true) {
        const options = response.data.suggestionlist.map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      }
    }, 300);
  };
  const handleUserDropdownChange = (selectedOptions) => {
    setUsersOption(selectedOptions || []);
  };
  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
      minHeight: "38px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "80px",
      overflowY: "auto",
      padding: "2px 4px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#ffecec" : state.isFocused ? "#fff5f6" : "#fff",
      color: state.isSelected ? "#d35258" : "#212129",
      fontWeight: state.isSelected ? "600" : "500",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
      margin: "2px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  const submitDockMaster = async () => {
    if (!dockCode.trim() || !dockName.trim() || !displayName.trim()) {
      setValidations(prev => ({
        ...prev,
        code: !dockCode.trim() ? "Code is required" : "",
        name: !dockName.trim() ? "Name is required" : "",
        display_name: !displayName.trim() ? "Display Name is required" : "",
      }));
      return;
    }

    setIsSubmitting(true);
    try {
      const dataBeforeSanitize = {
        id: dockId,
        code: dockCode,
        name: dockName,
        location_id: locationOption != null ? locationOption.value : "",
        available_in_time: startTime,
        available_out_time: endTime,
        description: description,
        display_name: displayName,
        departments: (selectedDept ?? []).filter((item) => item && item.value).map((item) => item.value),
        users: (usersOption ?? []).filter((item) => item && item.value).map((item) => item.value),
        customers: (selectedCustomer ?? []).filter((item) => item && item.value).map((item) => item.value),
        vendors: (selectedVendor ?? []).filter((item) => item && item.value).map((item) => item.value),
        products_types: (selectedProductType ?? []).filter((item) => item && item.value).map((item) => item.value),
      };
      const dataAfterSanitize = {};
      Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          dataAfterSanitize[key] = value;
        } else {
          dataAfterSanitize[key] = DOMPurify.sanitize(value);
        }
      });

      let response;
      if (!dockId || dockId === "") {
        response = await createDockSetupApi(dataAfterSanitize);
      } else {
        response = await updateDockSetupApi(dockId, dataAfterSanitize);
      }

      if (response && response.status === 200 && response.data?.success === true) {
        onSuccess(response.data);
      } else if (response && response.status === 400 && response.data?.error) {
        const validationTemp = {
          code: "",
          name: "",
          location_id: "",
          available_in_time: "",
          available_out_time: "",
          description: "",
          display_name: "",
          users: "",
          departments: "",
          customers: "",
          vendors: "",
          products_types: "",
        };
        Object.entries(response.data.error).forEach(([key, value]) => {
          validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : (typeof value === 'string' ? value : '');
        });
        setValidations(validationTemp);
      }
    } catch (err) {
      console.error("Error submitting dock master:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const printRef = useRef(null);
  /*  const downloadQR = () => {
     const canvas = printRef.current.querySelector("canvas");
     const url = canvas.toDataURL("image/png");
     const link = document.createElement("a");
     link.href = url;
     link.download = "qrcode.png";
     link.click();
   }; */

  const downloadQR = () => {
    const svgElement = printRef.current.querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    const DOMURL = window.URL || window.webkitURL || window;
    const url = DOMURL.createObjectURL(svgBlob);

    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const size = 800;
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext("2d");

      // Draw transparent background (optional, it's already transparent by default)
      ctx.clearRect(0, 0, size, size);

      ctx.drawImage(image, 0, 0, size, size);

      // ✅ Convert to PNG and download
      const pngUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = `QR_${dockDetails?.code}.png`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      DOMURL.revokeObjectURL(url);
    };

    image.src = url;
  };

  /* const handlePrint = useReactToPrint({
    content: () => printRef.current, // Must return a DOM element
  }); */
  const handlePrint = () => {
    console.log(printRef.current.innerHTM);
    if (printRef.current) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
      <html>
        <head>
          <title>Print QR Code</title>
        </head>
        <body style="display: flex; justify-content: center; align-items: center;">
          ${printRef.current.innerHTML}
        </body>
      </html>
    `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  };
  return (
    <div style={overlayStyle}>
      {styleTag}
      <div style={containerStyle}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
          <h2 style={{ fontSize: "20px", fontWeight: "700", fontFamily: "Epilogue", color: "#172B4D" }}>{dockId != null && dockId !== "" ? "Edit" : "Add"} Dock</h2>
          <button
            style={{
              background: "none",
              border: "1px solid #D4DDE7",
              borderRadius: "100px",
              padding: "8px",
              height: "40px",
              width: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={onClose} // Use the correct function to close the modal
          >
            <img src={close} alt="close" style={{ width: "14px", height: "14px" }} />
          </button>
        </div>

        {/* Description */}
        <p
          style={{
            fontFamily: "Epilogue",
            fontWeight: "400",
            fontSize: "14px",
            color: "#212129",
            marginBottom: "20px",
            borderBottom: "1px solid #E5E7EB",
            paddingBottom: "20px",
          }}>
          Enter the details below to create a new dock and assign it to the respective person.
        </p>
        <Row className="px-0 mx-0">
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">
              {" "}
              Code<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <input
              type="text"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={dockCode}
              onChange={(event) => {
                setDockCode(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.code}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">
              {" "}
              Name<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <input
              type="text"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={dockName}
              onChange={(event) => {
                setDockName(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.name}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1">
              {" "}
              Display Name<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <input
              type="text"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={displayName}
              onChange={(event) => {
                setDisplayName(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.display_name}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-2">
              {" "}
              Location<span style={{ color: "#FF4444" }}>*</span>{" "}
            </div>
            <SearchWithAPI onDropdownChange={handleLocationDropdownChange} apiUrl={adminApiUrl + "get_location"} params={{}} placeholder={"Select"} selectedOption={locationOption} />
            <span className="field-error">{validations.location_id}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1"> Available From </div>
            <input
              type="time"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={startTime}
              onChange={(event) => {
                setStartTime(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.available_in_time}</span>
          </Col>

          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-1"> Available To </div>
            <input
              type="time"
              placeholder="Enter here"
              className="input-field mt-1 w-100"
              value={endTime}
              onChange={(event) => {
                setEndTime(event.target.value); // Update state with input value
              }}
            />
            <span className="field-error">{validations.available_out_time}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-2">User</div>
            <CommonAsyncSelect
              isMulti
              cacheOptions
              value={usersOption}
              loadOptions={fetchOptions}
              onChange={(selectedOptions) => {
                handleUserDropdownChange(selectedOptions);
              }}
              defaultOptions
              placeholder="Search email..."
            />
            <span className="field-error">{validations.users}</span>
          </Col>

          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-2">Department</div>
            <CommonAsyncSelect isMulti cacheOptions value={selectedDept} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select Department" />
            <span className="field-error">{validations.departments}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-2">Vendor</div>
            <CommonAsyncSelect isMulti cacheOptions value={selectedVendor} loadOptions={getVendorData} onChange={handleVendorChange} defaultOptions placeholder="Select Vendor" />
            <span className="field-error">{validations.vendors}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-2">Customer</div>
            <CommonAsyncSelect isMulti cacheOptions value={selectedCustomer} loadOptions={getCustomerData} onChange={handleCustomerChange} defaultOptions placeholder="Select Customer" />
            <span className="field-error">{validations.customers}</span>
          </Col>
          <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
            <div className="field-title mb-2">Product Type</div>
            <CommonAsyncSelect isMulti cacheOptions value={selectedProductType} loadOptions={getProductTypeData} onChange={handleProductTypeChange} defaultOptions placeholder="Select Product Type" />
            <span className="field-error">{validations.products_types}</span>
          </Col>
          <Col xs={12} sm={12} className="mt-2 px-0">
            <div className="field-title mb-2">Description</div>
            <textarea value={description} onChange={handleChange} placeholder="Enter your text here..." style={{ width: "100%", border: "1px solid #e5e5e5", height: "100px", borderRadius: "8px", padding: "10px", outline: "none", fontWeight: "400", color: "#172b4d", fontSize: "12px" }}></textarea>
            <span className="field-error">{validations.users}</span>
          </Col>
          {dockDetails.qr_code && (
            <Col xs={12} sm={12} className="mt-2 px-0">
              <div>
                <div
                  style={
                    {
                      /*  height: "280px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "10px",
                    padding: "16px",
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#fff",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", */
                    }
                  }>
                  <div className="heading-title mb-2">QR code</div>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "start", gap: "10px" }}>
                    <div ref={printRef} style={{ textAlign: "center" }}>
                      <QRCodeSVG value={dockDetails.qr_code ?? ""} size={160} bgColor="#ffffff" fgColor="#000000" level="H" includeMargin={true} />
                    </div>
                    <div style={{ gap: "10px" }}>
                      <button onClick={downloadQR} className="download-btn px-3">
                        <img src={download} alt="" /> Download
                      </button>
                      <button onClick={handlePrint} className="download-btn px-3 mt-2">
                        <img src={print} alt="" /> Print
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )}
        </Row>

        {/* Footer Buttons */}
        <div style={actionsStyle}>
          <button
            disabled={isSubmitting}
            style={{
              padding: "10px 20px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #D1D5DB",
              borderRadius: "12px",
              fontWeight: "600",
              fontSize: "14px",
              cursor: isSubmitting ? "not-allowed" : "pointer",
            }}
            onClick={onClose}>
            Cancel
          </button>
          <button
            onClick={submitDockMaster}
            disabled={isSubmitting}
            style={{
              padding: "10px 20px",
              backgroundColor: "#EF4444",
              color: "#FFFFFF",
              border: "none",
              borderRadius: "12px",
              fontWeight: "600",
              fontSize: "14px",
              cursor: isSubmitting ? "not-allowed" : "pointer",
              fontFamily: "Epilogue",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              opacity: isSubmitting ? 0.7 : 1,
            }}>
            {isSubmitting && (
              <div
                className="spinner-border spinner-border-sm text-light"
                role="status"
                style={{ width: "14px", height: "14px" }}
              ></div>
            )}
            {isSubmitting ? (dockId ? "Updating..." : "Saving...") : (dockId ? "Update" : "Save")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DockAdd;
